<template>
<div id="siteframe">
	<!-- content -->
	<div id="content">
		<div id="_page_content"><div class="column_100">
	<div id="main" min_height="400" style="; width: 100%"><div>
	<div class="heroband">
<h1>IBA - Infinitt Business Analytics</h1>
<p style="color:white !important;">Peace of Mind. Save Time. Inspire Confidence.</p>
</div></div>


<div>
	<!--
<div class="band bg-gray" style="background: #f2f2f2;" _mce_style="background: #f2f2f2;">
<div class="container center padded">
<div class="row">
<div class="col-md-4 col-xs-12"><img class="floater circle" src="/static/images/placeholder.png" _mce_src="/static/images/placeholder.png" />
<h3>Brady Giles</h3>
<p>CEO</p>
</div>
<div class="col-md-4 col-xs-12"><img class="floater circle" src="/static/images/placeholder.png" _mce_src="/static/images/placeholder.png" />
<h3>Jorge Encinas</h3>
<p>Data Engineer</p>
</div>
<div class="col-md-4 col-xs-12"><img class="floater circle" src="/static/images/placeholder.png" _mce_src="/static/images/placeholder.png" />
<h3>Brittany Mullen</h3>
<p>Data Engineer</p>
</div>
</div>
</div>
</div>
--></div>


<div>
	<div class="container">
<div class="inset">
<h2>Infinitt provides healthcare data analytics and visualization. Our passion is delivering actionable data and insight through our robust analytics software, pulling data from customer's RIS/PACS and billing applications. Our clients use this critical information to increase productivity, decrease cost and ultimately make data driven decisions. IBA's analytics software is designed by radiologists and operators who are acutely familiar with the day-to-day needs of imaging practices, centers and departments.</h2>
<h3>IBA - Infinitt Business Analytics</h3>
<p style="color: #8B8B8B!important;">IBA Specialists<br><a href="tel:877-387-6960">877-387-6960</a><br><a href="mailto:info@infinittna.com">info@infinittna.com</a></p>

</div>
</div>
<div class="container center">
            <div id="google-map-wrapper">

            <iframe :src="mapUrl" width="600" height="450" frameborder="0" 
            style="border: 2px solid grey; box-shadow: -4px -3px 3px 1px #cccbcb; border-radius: 11px; margin-bottom:100px;" allowfullscreen loading="lazy"></iframe>
        </div>


</div>
</div>


<div>
	<div class="center"><img alt="IBA - Infinitt Business Analytics" class="responsive" src="/static/images/herographic-laptop-ipad.png" style="max-width: 700px;"></div></div>


</div></div>
<div style="clear: both;"></div>
</div>		<div style="clear: both;">
    
</div>
	</div>
    <div>
	
</div></div>
	<!-- end content -->	

</template>

<script>
    import {EventBus} from '../event-bus.js'

    export default {
        name: 'about',
        data () {
            return {
               mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.863614465971!2d-75.17716118459543!3d40.69900127933334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c46d952762b63f%3A0xf59392bc59c2ac0c!2s755%20Memorial%20Pkwy%20%23304%2C%20Phillipsburg%2C%20NJ%2008865!5e0!3m2!1sen!2sus!4v1646153556475!5m2!1sen!2sus"
            }
        },
        mounted(){

            
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/About.vue